export const getFilenameExtension = (filename) => {
    var _a;
    return ((_a = filename
        .split('.')
        .pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase())
        || '';
};
